const TranTypeApply = 'Apply';
const TranTypeAnnualReturn = 'AnnualReturn';
const TranTypeRenew = 'Renew';
const TranTypeNotificationChange = 'NotificationChange';

const LicTypeInd = 'CHARITABLE_INDVL';
const LicTypeCorp = 'CHARITABLE_CORP';

const roles = [
  {
    value: 'director',
    label: 'Director'
  },
  {
    value: 'director-of-nursing',
    label: 'Director of nursing'
  },
  {
    value: 'secretary',
    label: 'Secretary'
  },
  {
    value: 'other',
    label: 'Other'
  }
];

export const APPLICANT_TYPE_Organisation = 'Organisation';
export const APPLICANT_TYPE_Individual = 'Individual';

export const APPLICATION_TYPE_NotificationChange = 'NotificationChange';

export {
  roles,
  TranTypeApply,
  TranTypeRenew,
  TranTypeAnnualReturn,
  TranTypeNotificationChange,
  LicTypeInd,
  LicTypeCorp
};
